/**
 * @file index.js
 * @author Fernando Ruano
 * @description Initialize PatientsCreation View.
 */

// Commons
import {
  mapStateToProps,
  mapDispatchToProps
} from '@nephro/commons/mapReduxCRUD/index';

// Dependencies
import { connect } from 'react-redux';

// View
import View from './patientCreationView';

export const mapStateToPropsPatientCreation = mapStateToProps;
export const mapDispatchToPropsPatientCreation = mapDispatchToProps;

export default connect(
  mapStateToPropsPatientCreation,
  mapDispatchToPropsPatientCreation
)(View);
